import SelfServePostBuilderSidePanelConstants, { SelfServePostBuilderSidePanelTypes } from './SelfServePostBuilderSidePanelConstants';

export const displayRecipientManager = () => (
  (dispatch) => {
    dispatch({
      type: SelfServePostBuilderSidePanelConstants.DISPLAY_PANEL_TYPE,
      panelType: SelfServePostBuilderSidePanelTypes.RECIPIENT_MANAGER,
    });
  }
);

export const displayOrganizer = () => (
  (dispatch) => {
    dispatch({
      type: SelfServePostBuilderSidePanelConstants.DISPLAY_PANEL_TYPE,
      panelType: SelfServePostBuilderSidePanelTypes.SECTION_ORGANIZER,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SelfServePostBuilderSidePanelActions.jsx